import { render, staticRenderFns } from "./ns-avatar.vue?vue&type=template&id=054c98f1&"
import script from "./ns-avatar.vue?vue&type=script&lang=ts&"
export * from "./ns-avatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports